module.exports = __webpack_public_path__ + "static/media/costMonitoring.03147699.mp3";